import { Box } from "@mui/material";
import "../css/FadeInOut.css";
export const FadeInOut: React.FC = () => <Box className="elementToFadeInAndOut">・ ・ ・ ・ ・</Box>;
